import React from "react";
import "./TermCondition.scss";



const TermCondition = () => (

  <div className="termcondition-container">
    <h1 className="heading">Terms and Conditions</h1>

    
<p><strong>Effective Date: 1st May 2025</strong></p>

<p>Please read these Terms and Conditions (“Terms”) carefully before using the Aerial Borne platform.</p>

<p>These Terms govern your access to and use of our services as a <strong>customer</strong>, <strong>certified drone operator</strong>, or <strong>visitor</strong>. By using Aerial Borne, you agree to comply with and be legally bound by these Terms.</p>

<p>If you do not agree to these Terms, do not use our services.</p>


<h2>1. Definitions</h2>
<ul>
  <li><strong>“Platform”</strong> refers to the Aerial Borne website, services, and tools.</li>
  <li><strong>“Customer”</strong> means any individual or business seeking drone services through Aerial Borne.</li>
  <li><strong>“Operator” or “Pilot”</strong> means a certified individual or organization offering drone services through Aerial Borne.</li>
  <li><strong>“User”</strong> refers to any person using the Platform, including both Customers and Operators.</li>
  <li><strong>“Services”</strong> means all offerings and functionalities made available through the Platform.</li>
</ul>



<h2>2. Eligibility</h2>
<p>You must be at least 18 years old and legally authorized to enter into binding agreements to use Aerial Borne. Operators must hold valid certifications as per <strong>DGCA (Directorate General of Civil Aviation)</strong> or relevant aviation authority guidelines.</p>


<h2>3. Account Registration</h2>
<p>To use Aerial Borne, you must register an account and provide accurate, complete, and updated information. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</p>

<p>We reserve the right to suspend or terminate accounts that provide false information or breach these Terms.</p>

<h2>4. User Responsibilities</h2>

<h3>a. Customers</h3>
<ul>
  <li>Must provide accurate project requirements, deadlines, and site access if applicable</li>
  <li>Must make payments on time as agreed during booking</li>
  <li>Must treat Operators with professionalism and respect</li>
</ul>

<h3>b. Operators</h3>
<ul>
  <li>Must only accept work within their certified scope of operations</li>
  <li>Must ensure compliance with all applicable DGCA laws and airspace regulations</li>
  <li>Must complete accepted projects to the agreed standards and timelines</li>
  <li>Must maintain insurance and drone licensing where required</li>
</ul>


<h2>5. Platform Use Guidelines</h2>
<p>You agree not to:</p>
<ul>
  <li>Misrepresent your identity, qualifications, or experience</li>
  <li>Post false or misleading information or reviews</li>
  <li>Use the Platform for illegal or unauthorized purposes</li>
  <li>Attempt to gain unauthorized access to other users’ accounts</li>
  <li>Upload or transmit malicious code, spam, or harmful content</li>
  <li>Circumvent the platform to conduct transactions outside of Aerial Borne</li>
</ul>

<p>Violations may result in account suspension or legal action.</p>


   
<h2>6. Payment Terms</h2>

<h3>For Customers:</h3>
<ul>
  <li>Project fees will be shown clearly during booking</li>
  <li>Payment must be made through Aerial Borne’s secure system</li>
  <li>Refunds, if applicable, will follow our cancellation and dispute policy</li>
</ul>

<h3>For Operators:</h3>
<ul>
  <li>Payments will be released upon project completion and customer confirmation</li>
  <li>Fees or commissions may be deducted by Aerial Borne (clearly shown before acceptance)</li>
  <li>Operators are responsible for tax compliance on earnings</li>
</ul>
<h2>7. Service Matching and Limitations</h2>
<p>Aerial Borne facilitates the connection between customers and drone operators. We do not directly provide drone services, nor are we liable for the conduct, quality, or outcome of services rendered by third-party Operators.</p>
<p>We verify certifications but do not guarantee performance. Users are expected to exercise due diligence.</p>



<h2>8. Cancellations and Disputes</h2>
<p>Each project is subject to cancellation and dispute resolution policies:</p>
<ul>
  <li>Customers must notify cancellations in writing with adequate notice</li>
  <li>Operators must notify of delays or inability to complete services as soon as possible</li>
  <li>Disputes will be mediated by Aerial Borne where possible</li>
  <li>Final resolutions may involve refunds, reassignments, or withholding of payments</li>
</ul>
<p>Aerial Borne’s decision on disputes will be final and binding unless otherwise required by law.</p>



<h2>9. Intellectual Property</h2>
<p>All content on the Platform—including logos, text, UI elements, and trademarks—is the property of Aerial Borne or its licensors. You may not reproduce, distribute, or create derivative works without written permission.</p>
<p>Project data submitted by users remains their property, but you grant Aerial Borne a license to store and process this data to facilitate services.</p>


<h2>10. Privacy</h2>
<p>Your use of Aerial Borne is also governed by our <a href="[Insert Privacy Policy URL]">Privacy Policy</a>. By using the Platform, you consent to the collection, use, and sharing of your data as described therein.</p>



<h2>11. Limitation of Liability</h2>
<p>To the fullest extent permitted by law, Aerial Borne will not be liable for:</p>
<ul>
  <li>Losses resulting from incorrect use of the Platform</li>
  <li>Errors or omissions by Operators or Customers</li>
  <li>Business interruptions or indirect damages</li>
  <li>Any action outside our reasonable control</li>
</ul>
<p>Total liability shall not exceed the amount paid to Aerial Borne in the 12 months preceding the claim.</p>



<h2>12. Indemnity</h2>
<p>You agree to indemnify and hold harmless Aerial Borne, its officers, directors, employees, and partners from any claims, damages, liabilities, or legal fees arising from your use of the Platform or violation of these Terms.</p>



<h2>13. Termination</h2>
<p>We reserve the right to terminate or suspend your account if you violate these Terms, misuse the platform, or engage in fraudulent activity. You may close your account at any time by contacting our support team.</p>



<h2>14. Modifications to Terms</h2>
<p>We may update these Terms occasionally. When we do, we will revise the “Effective Date” above and notify you via the platform or email. Continued use after such changes constitutes acceptance of the new Terms.</p>

<h2>15. Governing Law</h2>
<p>These Terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts located in New Delhi.</p>



<h2>16. Contact Us</h2>
<p>For questions or concerns regarding these Terms, please contact:</p>

<p><strong>Aerial Borne Support</strong></p>

<p>📩 Email: <a href="mailto:support@aerialborne.com">support@aerialborne.com</a></p>
<p>📞 Phone: +91-7357017420</p>
<p>📍 Address: <strong>2nd Floor Plot No.4, Minarch Tower Sector-44, Gurgaon, Haryana, India, <a href="https://www.falconebiz.com/company/122003.html" target="_blank">122003</a></strong></p>


  </div>

);

export default TermCondition;
